<p>Der Rechnung zugeordnete Dokumente: {{ projectId }}</p>

<clr-datagrid [clrDgLoading]="loading">
  <clr-dg-column>Dateibeschreibung</clr-dg-column>
  <clr-dg-column>Dateiname</clr-dg-column>
  <clr-dg-column>Typ</clr-dg-column>
  <clr-dg-column>Dateityp</clr-dg-column>
  <clr-dg-column>Hochgeladen am</clr-dg-column>
  <clr-dg-column></clr-dg-column>

  <clr-dg-placeholder>Keine Dateien zu dieser Rechnung vorhanden!</clr-dg-placeholder>

  <clr-dg-row *ngFor="let files of invoiceFiles">
    <clr-dg-action-overflow>
      <button class="action-item" *ngIf="files.fileType === 'application/pdf'" (click)="showModal(files.id)">Show PDF</button>
      <button class="action-item" (click)="loadFile(files.id, files.fileName)">Download</button>
    </clr-dg-action-overflow>
    <clr-dg-cell>{{ files.description }}</clr-dg-cell>
    <clr-dg-cell>{{ files.fileName }}</clr-dg-cell>
    <clr-dg-cell>{{ files.document_type }}</clr-dg-cell>
    <clr-dg-cell>{{ files.fileType }}</clr-dg-cell>
    <clr-dg-cell>{{ files.time }}</clr-dg-cell>
    <clr-dg-cell (click)="deleteFile(files.id, files.fileName)"><cds-icon shape="times-circle" class="is-solid"></cds-icon></clr-dg-cell>
  </clr-dg-row>
</clr-datagrid><br />
<button class="btn btn-primary btn-sm" (click)="showFileUploader()">Datei hochladen</button>
<br />
<div *ngIf="showFileUpload">
  <h3>Datei für diese Rechnung hinzufügen</h3>
  <app-upload [componentId]="'0'" [companyId]=0 [projectId]=projectId [jobId]=jobId [subId]=0 [docType]=3 (closeModalEvent)="closeModal($event)"></app-upload>
</div>


<ng-container *ngIf="showPdf">
  <clr-modal id="pdfViewer" [(clrModalOpen)]="showPdf" [clrModalStaticBackdrop]="false">
    <h3 class="modal-title">{{ modalContent }}</h3>
    <div class="modal-body">
      <ngx-extended-pdf-viewer [src]="modalUrl" useBrowserLocale="true" height="85vh" [textLayer]="true"></ngx-extended-pdf-viewer>
    </div>
  </clr-modal>
</ng-container>
